module.exports = __webpack_public_path__ + "media/images/playbook-cover-807833d45e8d72017cf1380ef0f1fca9.png";